module.exports = __webpack_public_path__ + "img/s2.1d67fb87.png";